<h2 mat-dialog-title>Configurar fases del pipeline</h2>

<mat-dialog-content [formGroup]="phases_form">
  <p class="hint">
    Define el nombre, el orden y el número recomendado de candidatos en entrada y salida (valores absolutos, no porcentajes) para iluminar
    el pipeline.
  </p>

  <div formArrayName="phases" class="phases-list">
    @for (job_vacancy_phase of sorted_phases(); track job_vacancy_phase.id; let index = $index) {
      <section class="phase-card" [formGroupName]="index">
        <div class="phase-card-header">
          <h3>{{ job_vacancy_phase.type_label }}</h3>
          <div class="phase-order-actions">
            <button mat-icon-button type="button" aria-label="Subir fase" [disabled]="index === 0" (click)="movePhaseUp(index)">
              <mat-icon>arrow_upward</mat-icon>
            </button>
            <button
              mat-icon-button
              type="button"
              aria-label="Bajar fase"
              [disabled]="index === sorted_phases().length - 1"
              (click)="movePhaseDown(index)"
            >
              <mat-icon>arrow_downward</mat-icon>
            </button>
          </div>
        </div>

        <mat-form-field class="full-width">
          <mat-label>Nombre de la fase</mat-label>
          <input matInput formControlName="name" />
        </mat-form-field>

        <div class="scores-grid">
          <mat-form-field>
            <mat-label>Entrada mínima</mat-label>
            <input matInput type="number" min="0" placeholder="Ej. 5" formControlName="recommended_min_input_score" />
          </mat-form-field>
          <mat-form-field>
            <mat-label>Entrada máxima</mat-label>
            <input matInput type="number" min="0" placeholder="Ej. 20" formControlName="recommended_max_input_score" />
          </mat-form-field>
          <mat-form-field>
            <mat-label>Salida mínima</mat-label>
            <input matInput type="number" min="0" placeholder="Ej. 2" formControlName="recommended_min_output_score" />
          </mat-form-field>
          <mat-form-field>
            <mat-label>Salida máxima</mat-label>
            <input matInput type="number" min="0" placeholder="Ej. 10" formControlName="recommended_max_output_score" />
          </mat-form-field>
        </div>
      </section>
    }
  </div>
</mat-dialog-content>

<mat-dialog-actions align="end">
  <button mat-button type="button" (click)="cancel()">Cancelar</button>
  <button mat-flat-button color="accent" type="button" [disabled]="loading() || phases_form.invalid" (click)="save()">Guardar</button>
</mat-dialog-actions>
